import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MainServiceService } from '../main-service.service';
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.css']
})
export class DynamicFormComponent implements OnInit {
  isLoading = false;
  formQ;
  formInstance: any = {
    formDefination: {}
  };
  imgStyle = 'no-repeat fixed center center / cover;';
  defaultTextSize = '14px';
  defaultSpan = 'col-xs-4'
  defaultTextColor = 'gray';
  constructor(private activeRoute: ActivatedRoute, private mainServiceService: MainServiceService
    , public dialog: MatDialog) {
    this.activeRoute.queryParams.subscribe(params => {
      this.formQ = params['q'];
    });
  }
  ngOnInit() {
    this.isLoading = true;
    this.mainServiceService.getFormInstance(this.formQ).subscribe((response: any) => {
      this.isLoading = false;
      if (response) {
        let data = JSON.parse(response);
        this.formInstance = data.objectData;
        if (this.formInstance.formDefination.span) {
          this.defaultSpan = 'col-sm-12 col-md-' + this.formInstance.formDefination.span;
        }
        if (this.formInstance.formDefination.textSize) {
          this.defaultTextSize = this.formInstance.formDefination.textSize + 'px';
        }
        if (this.formInstance.formDefination.textColor) {
          this.defaultTextColor = this.formInstance.formDefination.textColor;
        }
      }
    });
  }
  getCatalog(name) {
    if ('Class' == name) {
      return this.formInstance.formDefination.catalogs.Class;
    }
    if ('Courses' == name) {
      return this.formInstance.formDefination.catalogs.Courses;
    }
    if ('Subjects' == name) {
      return this.formInstance.formDefination.catalogs.Subjects;
    }
    if ('Gender' == name) {
      return this.formInstance.formDefination.catalogs.Gender;
    }

  }
  save(action) {
    let allOk = true;
    if (this.formInstance.id && action == 'submit') {
      this.formInstance.formDefination.fields.forEach(x => {
        if (x.required == 'true' && (x.value == null || x.value == '' || x.value == 'undefined')) {
          Swal('Please fill all mandatory fields', x.title + ' is required', 'warning');
          allOk = false;
          return;
        }
        if(!this.validateFormField(x)){
          x.error=x.validationMsg;
          allOk=false;
        }else{
          x.error=null;
        }
      });
    }
    if (!allOk) {
      return;
    }
    this.isLoading = true;
    this.mainServiceService.saveForm(this.formQ, this.formInstance, action).subscribe((response: any) => {
      this.isLoading = false;
      if (response) {
        let data = JSON.parse(response);
        // Swal('', data.message, data.status.toLowerCase());   
        //if(!this.formInstance.id){
        this.formInstance = data.objectData;
        // } 
      }
    });
  }
  resetAll() {
    this.save('reset');
  }
  reSentOtp() {
    this.save('RE-SEND-OTP');
  }
  validateFormField(formField) {
    //var re = /\S+@\S+\.\S+/;
    if (!formField.pattern || !formField.value) {
      return true;
    } else {
      var regExp = new RegExp(formField.pattern);
      return regExp.test(formField.value);
      //return formField.pattern.test(formField.value);
    }
  }
}



// WEBPACK FOOTER //
// D:/Laxmi/angular/forms/XpressForms/src/app/dynamic-form/dynamic-form.component.ts